import * as stylex from '@stylexjs/stylex';
import { colors } from '../theme/colors.stylex';
import { controlMetrics } from '../theme/controls.stylex';

const slideUp = stylex.keyframes({
  from: { opacity: 0, transform: 'translateY(2px)' },
  to: { opacity: 1, transform: 'translateY(0)' },
});
const slideDown = stylex.keyframes({
  from: { opacity: 0, transform: 'translateY(-2px)' },
  to: { opacity: 1, transform: 'translateY(0)' },
});
const slideLeft = stylex.keyframes({
  from: { opacity: 0, transform: 'translateX(2px)' },
  to: { opacity: 1, transform: 'translateX(0)' },
});
const slideRight = stylex.keyframes({
  from: { opacity: 0, transform: 'translateX(-2px)' },
  to: { opacity: 1, transform: 'translateX(0)' },
});

export const overlayStyles = stylex.create({
  panel: {
    boxSizing: 'border-box',
    backgroundColor: colors.background,
    borderWidth: controlMetrics.borderWidth,
    borderStyle: 'solid',
    borderColor: colors.menuBorder,
    borderRadius: '0.5rem',
    outlineStyle: 'none',
  },
  outline: { outlineStyle: 'none' },
  motion: {
    animationDuration: '400ms',
    animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
    animationName: {
      'default': 'none',
      ':is([data-side="bottom"])': slideUp,
      ':is([data-side="top"])': slideDown,
      ':is([data-side="left"])': slideRight,
      ':is([data-side="right"])': slideLeft,
    },
  },
  arrow: {
    marginTop: '-0.4375rem',
    width: '0.9375rem',
    height: '0.9375rem',
    transform: 'rotate(45deg)',
    borderWidth: 0,
    borderRightWidth: controlMetrics.borderWidth,
    borderBottomWidth: controlMetrics.borderWidth,
    borderStyle: 'solid',
    borderColor: colors.menuBorder,
    backgroundColor: colors.background,
    fill: 'transparent',
  },
});

export const menuStyles = stylex.create({
  content: {
    position: 'relative',
    zIndex: 1200,
    minWidth: '1.5rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    color: colors.menuText,
  },
  subContent: { zIndex: 1000 },
  item: {
    position: 'relative',
    display: 'flex',
    minHeight: '1.6875rem',
    cursor: 'pointer',
    alignItems: 'center',
    paddingLeft: '1.1875rem',
    paddingRight: '1.1875rem',
    lineHeight: 1,
    outlineStyle: 'none',
    userSelect: 'none',
    color: colors.menuText,
    backgroundColor: { 'default': 'transparent', ':hover': colors.menuHover },
  },
  fixedHeight: { height: '1.6875rem' },
  subTrigger: { height: '1.6875rem', justifyContent: 'space-between', paddingRight: 0 },
  label: { marginLeft: '0.25rem', fontSize: '0.8125rem', color: colors.menuText, fontWeight: 400, fontStyle: 'normal' },
  subLabel: { fontWeight: 600 },
  disabled: { pointerEvents: 'none' },
  disabledText: { color: colors.menuTextDisabled },
  dimmed: { opacity: 0.3 },
  icon: { width: '1.125rem' },
  iconColor: { color: colors.menuText },
  iconSlot: { minWidth: '1.25rem' },
  row: { display: 'flex' },
  chevronSlot: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  chevron: { marginLeft: '1rem', marginRight: '0.5rem', transform: 'rotate(270deg)' },
  separator: { marginTop: '0.5rem', marginBottom: '0.5rem', height: '1px', backgroundColor: colors.menuBorder },
});
